module.exports = __webpack_public_path__ + "SourceSansPro-Regular.ba6cad25afe01d394e83.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/erikh/GitHub/Brickchain/oidc-demo/frontend/src/assets/fonts/SourceSansPro-Regular.ttf
// module id = ../../../../../src/assets/fonts/SourceSansPro-Regular.ttf
// module chunks = styles